import 'react';
import { BsSquare } from '@react-icons/all-files/bs/BsSquare';
import { decorateComponent } from '../../documentComponents/decorateComponent.js';
import { Block as Block$1 } from './Block.js';
import { BlockInspector } from './BlockInspector/BlockInspector.js';
import { jsx } from '@emotion/react';

var Block = decorateComponent(Block$1, 'block', {
  id: 'block',
  label: '블럭',
  defaultProps: {
    margin: {
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    },
    padding: {
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    },
    border: {
      width: 0,
      color: '#000000',
      radius: 0
    }
  },
  renderIcon: function renderIcon() {
    return jsx(BsSquare, null);
  },
  renderInspector: BlockInspector
});

export { Block as default };
//# sourceMappingURL=index.js.map
